import { createSlice } from "@reduxjs/toolkit";
import { shippingChargeApiSlice } from "./shippingChargeApiSlice";

export const initialState = {
  all: {
    data: [],
    size: 10,
    totalData: 0,
    page: 1,
  },
  one: {
    is_active: false,
    use_weight: false,
    weight_price: [],
    shipping_type: [],
  },
  query: {
    page: 1,
    size: 10,
  },
  static: [],
  loading: false,
  errors: {},
  all: {
    data: [],
    size: 10,
    totalData: 0,
    page: 1,
  },
};

export const shippingChargeSlice = createSlice({
  name: "shippingCharge",
  initialState,
  reducers: {
    setOneValue: (state, action) => {
      if (action.payload.key1 === "shipping_type") {
        state.one[action.payload.key1][action.payload.index][
          action.payload.key2
        ] = action.payload.value;
      } else {
        state.one[action.payload.key] = action.payload.value;
        state.errors[action.payload.key] = "";
      }
    },
    clearErrors: (state, action) => {
      state.errors = initialState.errors;
    },
    clearQuery: (state, action) => {
      state.query = initialState.query;
    },
    clearOne: (state, action) => {
      state.one = initialState.one;
    },
    setQueryValue: (state, action) => {
      if (action.payload.key === "set_by") {
        state.query[action.payload.key] = action.payload.value;
        state.one[action.payload.key] = action.payload.value;
      } else {
        state.one[action.payload.key] = action.payload.value;
      }
    },
    addNewTypeObjectToArray: (state, action) => {
      state.one[action.payload.key] = action.payload.value;
    },
    addObjectToArray: (state, action) => {
      state.one.weight_price = [...state.one.weight_price, action.payload];
      let lastIndex = state.one.weight_price.length - 1;

      if (state.one.weight_price.length > 0) {
        state.one.weight_price[lastIndex].to = Infinity;
      }
    },
    removeObjectFromArray: (state, action) => {
      state.one.weight_price = state.one.weight_price.filter(
        (each, index) => index !== action.payload
      );
      // state.one.weight_price[state.one.weight_price.length - 1].to = Infinity;
    },
    removeNewTypeObjectToArray: (state, action) => {
      state.one.shipping_type = state.one.shipping_type.filter(
        (each, index) => index !== action.payload
      );
    },
    setValueToArray: (state, action) => {
      state.one.weight_price[action.payload.key][action.payload.name] =
        action.payload.value;

      if (action.payload.name === "to") {
        let lastIndex = state.one.weight_price.length - 1;
        if (state.one.weight_price.length > 1) {
          state.one.weight_price[action.payload.key + 1].from =
            action.payload.value;
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      shippingChargeApiSlice.endpoints.loadOneShippingCharge.matchFulfilled,
      (state, { payload }) => {
        state.one = payload.data;
      }
    );
  },
});

export const {
  setOneValue,
  clearErrors,
  clearQuery,
  clearOne,
  setQueryValue,
  addNewTypeObjectToArray,
  addObjectToArray,
  removeObjectFromArray,
  removeNewTypeObjectToArray,
  setValueToArray,
} = shippingChargeSlice.actions;

export default shippingChargeSlice.reducer;
